import { post } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getCriterias = async (payload) => {
  const builder = new UrlBuilder(`/assessment/get-criterias`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getQuestions = async (payload) => {
  const builder = new UrlBuilder(`/assessment/get-questions`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const askQuestions = async (payload) => {
  const builder = new UrlBuilder(`/bedrock/ask-question`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const validateAnswer = async (payload) => {
  const builder = new UrlBuilder(`/bedrock/validate-response`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
